import axios from "axios";
import { APIURL } from "../../../Global";

export const makeApiCall = async ({ method, endpoint, data }) => {
  const tokenString = sessionStorage.getItem("usertoken");
  const token = tokenString?.replace(/["]+/g, "");
  try {
    const config = {
      method,
      url: `${APIURL}${endpoint}`,
      headers: {
        Authorization: "Token " + token,
        "Content-Type": "application/json",
      },
      data: { ...data}
    };

    const response = await axios(config);
    if (response.status === 200 && (response.data.status === undefined || response.data.status === "success")) {
      return { success: true, data: response.data };
    }
    return { success: false, error: response.data.message };
    
  } catch (error) {
    console.error("API Error:", error);
    return { 
      success: false, 
      error: error.response?.data?.message || 'An error occurred' 
    };
  }
};